import styled from 'styled-components';

export const StyledBouncingStar = styled.div`
  &.bounce {
    animation: bounce 0.5s ease-out;
  }

  @keyframes bounce {
    0% {
      transform: translateY(0);
    }
    30% {
      transform: translateY(-20px); /* Move up */
    }
    100% {
      transform: translateY(0); /* Back to original position */
    }
  }
`;
